import { DropdownItem, Icon, IconName, Link } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';

interface ErrorButtonProps {
    handleClick: () => void;
}

export const ErrorButton = ({ handleClick }: ErrorButtonProps) => (
    <DropdownItem
        onClick={handleClick}
        label={
            <>
                <LocalizedText textKey={TextKey.CommunicationHubErrorButtonPrefix} />
                {UnicodeEntity.Space}
                <Link variant="basic" href="#" underline>
                    <LocalizedText textKey={TextKey.CommunicationHubErrorButtonSuffix} />
                </Link>
            </>
        }
        leftDetail={<Icon value={IconName.ErrorCircle} />}
    />
);
